module.exports = __webpack_public_path__ + "img/foam_750.6ca42053.png";